import React, { useEffect, useState } from "react"
import { FormProvider, SubmitHandler, useForm } from "react-hook-form"
import { yupResolver } from '@hookform/resolvers/yup';
import CpntForm from "../../../components/forms/CpntForm";
import CpntFormSection from "../../../components/forms/CpntFormSection";
import CpntFormSectionContainer from "../../../components/forms/CpntFormSectionContainer";
import { IFormCompte, IFormCompteAlerteParution } from "./IFormCompte";
import TextInput from "../../../components/forms/TextInput";
import PhoneInputField from "../../../components/forms/PhoneInputField";
import { alerte_aParaitre, alerteaParaitreList, civiliteList, validationMode } from "../../../config/helpers";
import RadioInput from "../../../components/forms/RadioInput";
import { CompteSchema } from "./CompteSchema";
import { Button, Tab, Tabs } from "react-bootstrap";
import CpntFormSectionNavigation from "../../../components/forms/CpntFormSectionNavigation";
import { useNavigate } from 'react-router-dom';
import { useUpdateCompteAlerteParutionMutation, useUpdateCompteMutation } from "../../../redux/slice/api/FO/compteApi";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../redux/store";
import SelectInput from "../../../components/forms/SelectInput";
import { setCompte } from "../../../redux/slice/compte.slice";
import CheckboxInput from "../../../components/forms/CheckBoxInput";



const PageMonCompte: React.FC = () => {

  //const [IdCiviliteValue,setIdCiviliteValue] = useState<number|undefined>(undefined);
  //const { initialized: keycloakinitialized,keycloak } = useKeycloak();

  const rootCompte = useSelector((state: RootState) => state.compte);
  //const [compte,setCompte] = useState<ICompte|undefined>(undefined);
  const [currTabName, setcurrTabName] = useState("infos");

  const navigate = useNavigate();
  const dispatch = useDispatch();
  
  // const { data: CompteResult, isFetching, error } = useFetchCompteQuery(rootCompte?.Id ? rootCompte.Id.toString() : "", {
  //   refetchOnMountOrArgChange: true,
  //   skip: !keycloakinitialized || !keycloak.authenticated || !rootCompte
  // });


  const formMethodsProfil = useForm<IFormCompte>({
    mode: "all",
    reValidateMode: "onChange",
    defaultValues:{
      IdCivilite:-1
    },
    resolver: yupResolver(CompteSchema),
  });

  const [
    updateCompte,
    {
    isSuccess: isSuccessUpdateCompte,
    error: errorUpdateCompte,
    data: UpdateCompteReturnData,
  }] = useUpdateCompteMutation();

  const [
    updateCompteAlerteParution,
    {
    isSuccess: isSuccessUpdateCompteAlerteParution,
    error: errorUpdateCompteAlerteParution,
    data: UpdateCompteAlerteParutionReturnData,
  }] = useUpdateCompteAlerteParutionMutation();
  
  // setValue, setError, clearErrors,getValues
  const { handleSubmit:handleSubmitProfil,setValue:setvalueProfil } = formMethodsProfil; //reset:resetProfil,

  useEffect(() => {
    if (rootCompte) {
//Profil
      setvalueProfil("IdCivilite", rootCompte?.IdCivilite ? rootCompte.IdCivilite : -1);
      setvalueProfil("Nom", rootCompte?.Nom ? rootCompte.Nom : "");
      setvalueProfil("Prenom", rootCompte?.Prenom ? rootCompte.Prenom : "");
      setvalueProfil("Email", rootCompte?.Login ? rootCompte.Login : "");
      setvalueProfil("Telephone", rootCompte?.Telephone ? rootCompte.Telephone : "");
      setvalueProfil("IdAlerteParution", rootCompte?.IdAlerteParution ? rootCompte.IdAlerteParution : alerte_aParaitre.PasDeNotifications);
      setvalueProfil("RecevoirCommunications", rootCompte?.RecevoirCommunications ? rootCompte.RecevoirCommunications : false);
      setvalueProfil("RecevoirCommunicationsPartenaires", rootCompte?.RecevoirCommunicationsPartenaires ? rootCompte.RecevoirCommunicationsPartenaires : false)
//Alerte
      setValueAlerte("IdAlerteParution", rootCompte?.IdAlerteParution ? rootCompte.IdAlerteParution : alerte_aParaitre.PasDeNotifications);
    }
  }, [rootCompte])

  

  //useEffect(() => {
  //   if (UpdateCompteAlerteParutionReturnData?.Compte) {
  //     setvalueProfil("IdAlerteParution", UpdateCompteAlerteParutionReturnData?.Compte?.IdAlerteParution ? UpdateCompteAlerteParutionReturnData?.Compte?.IdAlerteParution : alerte_aParaitre.PasDeNotifications);
  //     setValueAlerte("IdAlerteParution", UpdateCompteAlerteParutionReturnData?.Compte?.IdAlerteParution ? UpdateCompteAlerteParutionReturnData?.Compte?.IdAlerteParution : alerte_aParaitre.PasDeNotifications);
  //   }
  // }, [UpdateCompteAlerteParutionReturnData])


useEffect(() => {
    if (errorUpdateCompte !== undefined || errorUpdateCompteAlerteParution !== undefined) {
      toast.warn("Les modifications n'ont pas été prises en compte");
      //setUpdateError(errorUpdateBO)
    }
}, [errorUpdateCompte,errorUpdateCompteAlerteParution])

useEffect(() => {
  if (isSuccessUpdateCompte) {
    toast.success("Les modifications ont bien été prises en compte.");
    if (UpdateCompteReturnData) {
      dispatch(setCompte(UpdateCompteReturnData?.Compte));
    }
  }
}, [isSuccessUpdateCompte])

useEffect(() => {
  if (isSuccessUpdateCompteAlerteParution) {
    toast.success("Les modifications ont bien été prises en compte.");
    if (UpdateCompteAlerteParutionReturnData) {
      setvalueProfil("IdAlerteParution", UpdateCompteAlerteParutionReturnData?.Compte?.IdAlerteParution ? UpdateCompteAlerteParutionReturnData?.Compte?.IdAlerteParution : alerte_aParaitre.PasDeNotifications);
      setValueAlerte("IdAlerteParution", UpdateCompteAlerteParutionReturnData?.Compte?.IdAlerteParution ? UpdateCompteAlerteParutionReturnData?.Compte?.IdAlerteParution : alerte_aParaitre.PasDeNotifications);
      dispatch(setCompte(UpdateCompteAlerteParutionReturnData?.Compte));
    }
  }
}, [isSuccessUpdateCompteAlerteParution])


const onSubmitProfil: SubmitHandler<IFormCompte> = (data) => {
    updateCompte(
      {
        ...data,
        Id:rootCompte.Id ? rootCompte.Id : -1,
        IdCivilite:data.IdCivilite,
        IdTypeCompte:rootCompte.IdTypeCompte ? rootCompte.IdTypeCompte : -1,
        Nom: data.Nom,
        Prenom: data.Prenom,
        Telephone: data.Telephone,
        Login:data.Email,
        RecevoirCommunications:data.RecevoirCommunications,
        RecevoirCommunicationsPartenaires:data.RecevoirCommunicationsPartenaires
      }
    );
  };

  const onErrorProfil = (errors: any) => {
    //
  };


  const formMethodsAlerte = useForm<IFormCompteAlerteParution>({
    mode: "all",
    reValidateMode: "onChange",
    //resolver: yupResolver(CompteSchema a def ??),
  });
  
  // setValue, setError, clearErrors,getValues
  const { handleSubmit:handleSubmitAlerte,setValue:setValueAlerte } = formMethodsAlerte; //reset:resetAlerte

  const onSubmitAlerte: SubmitHandler<IFormCompteAlerteParution> = (data) => {
    updateCompteAlerteParution(
      {
        Id:rootCompte.Id ? rootCompte.Id : -1,
        IdAlerteParution:data.IdAlerteParution
      }
    );
  };

  const onErrorAlerte = (errors: any) => {
  };
  

return (
    <>
      <div className="container text-center">
        <div className="row pt-3 pb-5">
          <div className="col col-12 ">
            <h2 className="titreModule titre-bleu"><i className="bi-person-circle pe-2" />Mon Compte</h2>
          </div>
        </div>
        <div className="row pt-3 pb-5">
          <div className="col col-md-10 offset-md-1 col-12 ">
          <Tabs defaultActiveKey={currTabName} id="uncontrolled-tab-example" className="onglet mb-3">
        <Tab eventKey="infos" title="Informations générales" onClick={() => setcurrTabName("infos")}>
        {rootCompte &&
        <FormProvider {...formMethodsProfil}>
            <form onSubmit={handleSubmitProfil((data) => onSubmitProfil(data),onErrorProfil)}>
              <CpntForm>
                <CpntFormSection pSectionLabel="Mes informations personnelles">
                      <CpntFormSectionContainer ColumnsSize={12} ColumnsSizesMd={[12,6,6,6,6,6]}>
                      {
                          <RadioInput
                          label="Civilité"
                          formName="IdCivilite"
                          ismandatory={true}
                          //defaultValue={IdCiviliteValue}
                          options={civiliteList.map((civ) => {
                            return {
                              id: civ.Id,
                              name: civ.Libelle,
                              value: civ.Id,
                            };
                          })}
                          />
                        }
                        <TextInput
                          label="Nom"
                          formName="Nom"
                          validationStyle={validationMode.classic}
                          placeholder="Nom"
                        />
                        <TextInput
                          label="Prénom"
                          formName="Prenom"
                          validationStyle={validationMode.classic}
                          placeholder="Prénom"
                        />
                        <TextInput
                          label="Email"
                          formName="Email"
                          validationStyle={validationMode.classic}
                          placeholder="Email"
                          disabled
                        />
                        <PhoneInputField
                          label="Téléphone"
                          formName="Telephone"
                          placeholder="Numéro de téléphone"
                        />
                        
                        
                      </CpntFormSectionContainer>
                      <CpntFormSectionContainer ColumnsSize={12} ColumnsSizesMd={[12,12]}>
                                                  <CheckboxInput
                                                      formName="RecevoirCommunications"
                                                      label={`J'accepte de recevoir les communications du portail "${process.env.REACT_APP_WEBSITE_TITLE}"`}
                                                      options={[
                                                        {
                                                          defaultChecked: rootCompte?.RecevoirCommunications === true 
                                                        },
                                                      ]}   
                                                      labelRight={true}   
                                                    />
                      
                                                    <CheckboxInput
                                                      formName="RecevoirCommunicationsPartenaires"
                                                      label={`J'accepte de recevoir les communications des partenaires du portail "${process.env.REACT_APP_WEBSITE_TITLE}"`}
                                                      options={[
                                                        {
                                                          defaultChecked: rootCompte?.RecevoirCommunicationsPartenaires === true 
                                                        },
                                                      ]} 
                                                      labelRight={true}   
                                                    />
                      </CpntFormSectionContainer>
                      <CpntFormSectionContainer ColumnsSize={12} ColumnsSizesMd={[6,6]}>
                        <Button
                                    onClick={async () => {
                                      navigate("/ModifierEmail");
                                    }}
                                    className="btn-secondary btn btn-primary col-12"
                                  >
                                    Modifier votre email
                        </Button>
                        <Button
                                    onClick={async () => {
                                      navigate("/ModifierMotdePasse");
                                    }}
                                    className="btn-secondary btn btn-primary col-12"
                                  >
                                    Modifier votre mot de passe
                        </Button>
                        </CpntFormSectionContainer>
                      <CpntFormSectionNavigation>
                        {/* <div></div> */}
                        <Button type="submit" className="col-12 btn-secondary">
                          Enregistrer
                        </Button>
                        {/* <div></div> */}
                      </CpntFormSectionNavigation>

                </CpntFormSection>
              </CpntForm>
            </form>
          </FormProvider>
        }
        </Tab>
        <Tab eventKey="alertes" title="Mes alertes" onClick={() => setcurrTabName("alertes")}>
        <FormProvider {...formMethodsAlerte}>
            <form onSubmit={handleSubmitAlerte((data) => onSubmitAlerte(data),onErrorAlerte)}>
              <CpntForm>
                <CpntFormSection pSectionLabel="Alertes dates de parution : gestion des notifications">
                  <CpntFormSectionContainer ColumnsSize={12}>
                  <SelectInput
                  label="Sélection des périodes"
                  formName="IdAlerteParution"
                  ismandatory={true}
                  options={[
                    ...alerteaParaitreList.map((tm) => ({
                      Libelle: tm.Libelle,
                      Id: tm.Id,
                    }))
                  ]}
                  // options={alerteaParaitreList.map((tc) => {
                  //   return {
                  //     Id: tc.Id,
                  //     Libelle: tc.Libelle,
                  //     //defaultChecked: civ.Id,
                  //   };
                  // })}
                />
                  </CpntFormSectionContainer>
                  <CpntFormSectionNavigation>
                        {/* <div></div> */}
                        <Button type="submit" className="btn-secondary col-12">
                          Enregistrer
                        </Button>
                        {/* <div></div> */}
                      </CpntFormSectionNavigation>
                </CpntFormSection>
              </CpntForm>
            </form>
        </FormProvider>
        </Tab>
      </Tabs>
        </div>
      </div>
    </div>
    </>
  );
};

export default PageMonCompte;


